require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.map");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.blog.benchmark.js");
goog.provide('com.wsscode.blog.benchmark');
/**
 * Runs `f` for `times` times, returns the average time to run it.
 *   Example:
 * 
 *    (bench 10000 #(do-something))
 */

com.wsscode.blog.benchmark.bench = function com$wsscode$blog$benchmark$bench(times, f) {
  var start = cljs.core.system_time();
  var n__4613__auto___20664 = times;
  var __20665 = 0;

  while (true) {
    if (__20665 < n__4613__auto___20664) {
      f.cljs$core$IFn$_invoke$arity$0 ? f.cljs$core$IFn$_invoke$arity$0() : f.call(null);
      var G__20666 = __20665 + 1;
      __20665 = G__20666;
      continue;
    } else {}

    break;
  }

  return (cljs.core.system_time() - start) / times;
};
/**
 * Compute multiple benchmarks together with names. Example:
 * 
 *    (bench-compare 10000
 *      {:op-a #(do-something)
 *       :other-op #(do-something-else)})
 */


com.wsscode.blog.benchmark.bench_compare = function com$wsscode$blog$benchmark$bench_compare(times, fns) {
  return cljs.core.into.cljs$core$IFn$_invoke$arity$3(cljs.core.PersistentArrayMap.EMPTY, cljs.core.map.cljs$core$IFn$_invoke$arity$1(function (p__20660) {
    var vec__20661 = p__20660;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__20661, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__20661, 1, null);
    return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [k, com.wsscode.blog.benchmark.bench(times, v)], null);
  }), fns);
};

Object.defineProperty(module.exports, "bench", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.benchmark.bench;
  }
});
Object.defineProperty(module.exports, "bench_compare", {
  enumerable: false,
  get: function get() {
    return com.wsscode.blog.benchmark.bench_compare;
  }
});